import React from 'react';
import Swiper from 'gatsby-theme-core/src/components/swiper';
import MediaPopupProvider from '../media-popup/provider';
import MediaPopup from '../media-popup/index';
import useMediaPopup from '../media-popup/use-media-popup';

const Media = ({
  images,
  name,
  imageOptions = ['w_848'],
  breakpoint = 576,
}) => {
  const { setImagesOpen, setCurrentImage } = useMediaPopup();
  return (
    <>
      <Swiper
        slides={
          images.map((image, index) => ({
            style: { cursor: 'pointer' },
            onClick: () => {
              setImagesOpen(true);
              setCurrentImage(index);
            },
            image,
            alt: `${name} afbeelding ${index + 1}`,
          }))
        }
        imageOptions={imageOptions}
        breakpoint={breakpoint}
      />
      <MediaPopup
        imageSlides={
          images.map((image, index) => ({
            image,
            alt: `${name} afbeelding ${index + 1}`,
          }))
        }
        imageOptions={[]}
      />
    </>
  );
};

const MediaWrapper = (props) => (
  <MediaPopupProvider>
    <Media {...props} />
  </MediaPopupProvider>
);

export default MediaWrapper;
